import { customColors, defaultColors } from '../tokens';
import { colorOpacity } from '../utils';

export const primary = '#5d3edb';

export const light = {
  primary,
  //secondary: '#8882F1',
  primaryNavBarBg: primary,
  secondaryNavBarBg: customColors.gray['400'],
  bodyBg: customColors.background,
  topNavSearchBg: '#9d8be8',

  cardBg: customColors.gray['0'],
  componentBorder: customColors.gray['100'],
  chartGridColor: customColors.gray['100'],

  selectedMenuBg: colorOpacity(primary, 0.05),
  selectedSideNavMenuBg: colorOpacity(primary, 0.1),
  menuColor: customColors.gray['200'],

  tableSelectedRowBg: customColors.blue['50'],
  //hover: '#F8F2FE',
  hover: '#F0E6FD', //colorOpacity(primary, 0.1)
  tableHeader: customColors.gray['300'],
  tableHeaderBg: customColors.gray['50'],
  tableRowBorder: customColors.gray['100'],

  edit: customColors.green['300'],
  delete: 'red',
  add: primary,
  critical: defaultColors.red['600'],
  high: '#df5d56',
  medium: '#da8b31',
  low: '#efb943',
  unknown: customColors.gray['200'],
  info: defaultColors.blue['300'],
  success: defaultColors.green['300'],
  error: defaultColors.red['500'],

  formFieldBorder: customColors.gray['100'],
  filterBorder: customColors.gray['200'],
  placeholder: customColors.gray['250'],

  pieChartBorder: customColors.gray['0'],
  gaugeChartBorder: customColors.gray['0'],

  sensitiveDataBg: '#404040',
  passed: '#9dc763',

  dashboardRowSubHeader: '#6c6c6c',
  selectIcon: '#6c6c6c',
  secondaryNavBarItem: '#6c6c6c',
  grey: '#6c6c6c',

  insights: '#e88120',
};
